export const Stat = ({
  label,
  value,
  isMuted,
}: {
  label: string
  value: React.ReactNode
  isMuted: boolean
}) => (
  <div className="flex flex-col gap-1">
    <span className="text-muted-foreground text-xs">{label}</span>
    <span
      className={
        isMuted
          ? 'font-medium text-muted-foreground tabular-nums'
          : 'font-medium tabular-nums'
      }
    >
      {value}
    </span>
  </div>
)
